/**
 * Generated by orval
 * Do not edit manually.
 * Veronics, Version=0.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ClassGetMyEnrolledClassesParams,
  ClassGetMyTeachingClassesParams,
  MyEnrolledClassListItemDTOQueryResultDTO,
  MyTeachingClassListItemDTOQueryResultDTO
} from './model';

import { customInstance } from '../custom-axios-instance';
import type { ErrorType } from '../custom-axios-instance';





export const classGetMyTeachingClasses = (
    params?: ClassGetMyTeachingClassesParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<MyTeachingClassListItemDTOQueryResultDTO>(
      {url: `/api/Class/my-teaching-classes`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getClassGetMyTeachingClassesQueryKey = (params?: ClassGetMyTeachingClassesParams,) => {
    return [`/api/Class/my-teaching-classes`, ...(params ? [params]: [])] as const;
    }

    
export const getClassGetMyTeachingClassesQueryOptions = <TData = Awaited<ReturnType<typeof classGetMyTeachingClasses>>, TError = ErrorType<unknown>>(params?: ClassGetMyTeachingClassesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classGetMyTeachingClasses>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClassGetMyTeachingClassesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof classGetMyTeachingClasses>>> = ({ signal }) => classGetMyTeachingClasses(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof classGetMyTeachingClasses>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ClassGetMyTeachingClassesQueryResult = NonNullable<Awaited<ReturnType<typeof classGetMyTeachingClasses>>>
export type ClassGetMyTeachingClassesQueryError = ErrorType<unknown>


export function useClassGetMyTeachingClasses<TData = Awaited<ReturnType<typeof classGetMyTeachingClasses>>, TError = ErrorType<unknown>>(
 params: undefined |  ClassGetMyTeachingClassesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof classGetMyTeachingClasses>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof classGetMyTeachingClasses>>,
          TError,
          Awaited<ReturnType<typeof classGetMyTeachingClasses>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClassGetMyTeachingClasses<TData = Awaited<ReturnType<typeof classGetMyTeachingClasses>>, TError = ErrorType<unknown>>(
 params?: ClassGetMyTeachingClassesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classGetMyTeachingClasses>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof classGetMyTeachingClasses>>,
          TError,
          Awaited<ReturnType<typeof classGetMyTeachingClasses>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClassGetMyTeachingClasses<TData = Awaited<ReturnType<typeof classGetMyTeachingClasses>>, TError = ErrorType<unknown>>(
 params?: ClassGetMyTeachingClassesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classGetMyTeachingClasses>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useClassGetMyTeachingClasses<TData = Awaited<ReturnType<typeof classGetMyTeachingClasses>>, TError = ErrorType<unknown>>(
 params?: ClassGetMyTeachingClassesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classGetMyTeachingClasses>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getClassGetMyTeachingClassesQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const classGetMyEnrolledClasses = (
    params?: ClassGetMyEnrolledClassesParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<MyEnrolledClassListItemDTOQueryResultDTO>(
      {url: `/api/Class/my-enrolled-classes`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getClassGetMyEnrolledClassesQueryKey = (params?: ClassGetMyEnrolledClassesParams,) => {
    return [`/api/Class/my-enrolled-classes`, ...(params ? [params]: [])] as const;
    }

    
export const getClassGetMyEnrolledClassesQueryOptions = <TData = Awaited<ReturnType<typeof classGetMyEnrolledClasses>>, TError = ErrorType<unknown>>(params?: ClassGetMyEnrolledClassesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classGetMyEnrolledClasses>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClassGetMyEnrolledClassesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof classGetMyEnrolledClasses>>> = ({ signal }) => classGetMyEnrolledClasses(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof classGetMyEnrolledClasses>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ClassGetMyEnrolledClassesQueryResult = NonNullable<Awaited<ReturnType<typeof classGetMyEnrolledClasses>>>
export type ClassGetMyEnrolledClassesQueryError = ErrorType<unknown>


export function useClassGetMyEnrolledClasses<TData = Awaited<ReturnType<typeof classGetMyEnrolledClasses>>, TError = ErrorType<unknown>>(
 params: undefined |  ClassGetMyEnrolledClassesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof classGetMyEnrolledClasses>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof classGetMyEnrolledClasses>>,
          TError,
          Awaited<ReturnType<typeof classGetMyEnrolledClasses>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClassGetMyEnrolledClasses<TData = Awaited<ReturnType<typeof classGetMyEnrolledClasses>>, TError = ErrorType<unknown>>(
 params?: ClassGetMyEnrolledClassesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classGetMyEnrolledClasses>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof classGetMyEnrolledClasses>>,
          TError,
          Awaited<ReturnType<typeof classGetMyEnrolledClasses>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClassGetMyEnrolledClasses<TData = Awaited<ReturnType<typeof classGetMyEnrolledClasses>>, TError = ErrorType<unknown>>(
 params?: ClassGetMyEnrolledClassesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classGetMyEnrolledClasses>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useClassGetMyEnrolledClasses<TData = Awaited<ReturnType<typeof classGetMyEnrolledClasses>>, TError = ErrorType<unknown>>(
 params?: ClassGetMyEnrolledClassesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classGetMyEnrolledClasses>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getClassGetMyEnrolledClassesQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



